import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';

import Header from '../header/header';
import SystemStatus from 'core/components/system-status';
import styles from './layout.styles';

const Layout = observer(({ children, classes }) => {
  return (
    <>
      <Header />
      <div className={classes.layout}>
        <SystemStatus />
        <div className={classes.container}>{children}</div>
      </div>
    </>
  );
});

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Layout);
